import { Action, Reducer } from 'redux';
import { AppThunkAction } from '.';
import moment from 'moment';

import config from './config';

let base = config.api;

const postHeaders = (body: string | null) : RequestInit => ({ credentials: "include" , method:"post", headers:{ "Content-Type": "application/json" }, body });
const postHeadersNoBody = () : RequestInit => ({ credentials: "include" , method:"post", headers:{ "Content-Type": "application/json" } });
const putHeadersNoBody = () : RequestInit => ({ credentials: "include" , method:"put", headers:{ "Content-Type": "application/json" } });
const getHeaders: RequestInit = { credentials: "include" , method:"get", headers:{ "Content-Type": "application/json" } };


export interface ReconcileItem {
    reference: string;
    policyRef: string;
    suffix: number;
    branch: number;
    transactionType: string;
    paid: number;
    outstanding: number;
    id: string;
    date: Date;
}

export interface ReconcileState {
    items: ReconcileItem[];
    branches: Array<number>;
    loadError: Date;
    loadCompleted: Date;
    reconcileError: Date;
    reconcileCompleted: Date;
}

interface LoadResponse {
    success: boolean;
    items: ReconcileItem[];
}

interface ReconcileResponse {
    success: boolean;
}

interface ReconcileActionPayload {
    items: ReconcileItem[];
}


const defaultState: ReconcileState = { items: [], branches: [], loadError: null, loadCompleted: null, reconcileCompleted: null, reconcileError: null  };

export interface LoadAction { type: 'LOAD' }
export interface LoadBranchesAction {type: 'LOAD_BRANCHES'}
export interface LoadFailedAction { type: 'LOAD_FAILED' }
export interface LoadCompletedAction { type: 'LOAD_COMPLETED', payload: LoadResponse }
export interface LoadBranchesCompletedAction { type: 'LOAD_BRANCHES_COMPLETED', payload: Array<number> }
export interface ReconcileAction { type: 'RECONCILE', payload: ReconcileActionPayload[] }
export interface ReconcileCompletedAction { type: 'RECONCILE_COMPLETED', payload: ReconcileResponse }
export interface ReconcileFailedAction { type: 'RECONCILE_FAILED' }

export type LoadActionUnion = LoadAction | LoadCompletedAction | LoadFailedAction | LoadBranchesAction | LoadBranchesCompletedAction;
export type ReconcileActionUnion = ReconcileAction | ReconcileCompletedAction | ReconcileFailedAction;
type KnownAction = LoadActionUnion | ReconcileActionUnion;

export const actionCreators = {
    
    load: (branch: number, start: Date, end: Date): AppThunkAction<LoadActionUnion> => (dispatch, getState) => {

        
        fetch(`${base}/api/reconcile/list?branch=${branch}&start=${moment(start).format('YYYY-MM-DD')}&end=${moment(end).format('YYYY-MM-DD')}`, getHeaders)
        .then(response => response.ok ? response.json() as Promise<LoadResponse> : null)
        .catch(reason => ({success: false}) as LoadResponse)
        .then(data => {
            if (data && data.success) {
                dispatch({ type: 'LOAD_COMPLETED', payload: data });
            }else {
                dispatch({ type: 'LOAD_FAILED' });
            }
        });

    },

    branches: (): AppThunkAction<LoadActionUnion> => (dispatch, getState) => {

        
        fetch(`${base}/api/reconcile/branches`, getHeaders)
        .then(response => response.ok ? response.json() as Promise<Array<number>> : null)
        .catch(reason => ([]) as Array<number>)
        .then(data => {
            if (data && data.length>0) {
                dispatch({ type: 'LOAD_BRANCHES_COMPLETED', payload: data });
            }else {
                dispatch({ type: 'LOAD_FAILED' });
            }
        });

    },
    
    reconcile: (items: ReconcileItem[]): AppThunkAction<ReconcileActionUnion> => (dispatch, getState) => {

        fetch(base+"/api/reconcile", postHeaders(JSON.stringify(items)))
        .then(data => data.ok ? data.json() as Promise<ReconcileResponse> : null)
        .catch(reason => ({success: false}) as ReconcileResponse)
        .then(ok => {
            if (ok && ok.success) {
                dispatch({type: 'RECONCILE_COMPLETED', payload: ok});
            }else {
                dispatch({type: 'RECONCILE_FAILED'})
            }
        });

    }
};

export const reducer: Reducer<ReconcileState> = (state: ReconcileState | undefined, incomingAction: Action): ReconcileState => {

    if (state === undefined) {
        return defaultState;
    }

    const action = incomingAction as KnownAction;
    switch (action.type) {
        case "LOAD_COMPLETED": 
            return {...state, items: action.payload.items, loadCompleted: new Date() };
        case "LOAD_BRANCHES_COMPLETED":
            return {...state, branches: action.payload, loadCompleted: new Date()};
        case "LOAD_FAILED":
            return {...state, items: [], loadError: new Date() }
        case "RECONCILE_COMPLETED":
            return {...state, reconcileCompleted: new Date() }
        case "RECONCILE_FAILED": 
            return {...state, reconcileError: new Date() }
        default:
            return state;
    }
};
